import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import duration from "dayjs/plugin/duration";
import { StorageHelper } from "@/utils/StorageHelper";
import { StorageName } from "@/utils/StorageHelper/constants";
import { TimeZones } from "@/constants";
import utc from "dayjs/plugin/utc";

const initializeTimeZone = () => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.extend(duration);

    const { read, write } = new StorageHelper(StorageName.AppTimeZone);

    let storedTimeZone = read<string>();

    if (!storedTimeZone) {
        storedTimeZone = dayjs.tz.guess();

        write(storedTimeZone);
    }

    dayjs.tz.setDefault(storedTimeZone || TimeZones.EuropeBerlin);
};
export { dayjs, initializeTimeZone };
